import * as React from 'react';
import {
  Button,
  ButtonWidth,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';
import {Modal} from '../../../components/Modal/Modal';
import {ModalButtons} from '../../../components/Modal/layout';
import {Content, Title} from '../../../shared/utils/sharedStyledElements';

type Props = {
  isOpen: boolean;
  close: () => void;
};

export function DeletedPracticeAccountModal({isOpen, close}: Props) {
  return (
    <Modal isOpen={isOpen} close={close}>
      <Title>Account not found</Title>
      <Content>
        We couldn't locate your account in our system. It seems the business
        accidentally deleted your profile. Please get in touch with the business
        to restore your account and regain access to the rewards program.
      </Content>
      <ModalButtons>
        <Button color="secondary" width={ButtonWidth.WIDE} onClick={close}>
          Close
        </Button>
      </ModalButtons>
    </Modal>
  );
}
